import React, { Component } from 'react';
import {Grid, Row, Col, Thumbnail, Tooltip, OverlayTrigger } from 'react-bootstrap';
import sites from './Sites.js'
import '../style.css'

class Preview extends Component {
  render() {
    return (
      <Grid className="container-fluid" id="section2">
        <Row>
          {sites.map((site, index) => {
            return (
            <Col key={index} lg={6} md={6} sm={6} xs={12}>
              <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'><strong>{site.name}</strong></Tooltip>}>
                <Thumbnail className='thumb' key={site.index} href={site.href} target="_blank" alt={site.name} src={site.img} />
              </OverlayTrigger>

            </Col>
          )})}
        </Row>
      </Grid>
    )
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview.js